module.exports = __webpack_public_path__ + "img/icon2.51a7a740.png";